export const GET_NEW_RIVIR_ALERTS = '/api/syndication/get-rivir-alerts';
export const MARK_RIVIR_ALERTS_AS_READ =
  '/api/syndication/mark-rivir-alert-as-read';
